export const AppURL = {
    dashboard: 'dashboard',
    organization: 'organization.html',
    version: 'version.html',
    public_version: 'versions.html',
    package: 'package',
    license: 'license',
    basket: 'basket',
    check: 'check'
};